import { createContext, useContext } from 'react';
import type { SettingsFeatureBundle } from '../types';

const SettingsBundleContext = createContext<SettingsFeatureBundle | null>(null);

export const SettingsBundleProvider = SettingsBundleContext.Provider;

export const useSettingsBundle = (): SettingsFeatureBundle => {
  const bundle = useContext(SettingsBundleContext);
  if (!bundle) {
    throw new Error('Settings bundle context is missing.');
  }
  return bundle;
};
